import { Controller } from "@hotwired/stimulus"

// Replaces the "Show more" button with a spinner on click.
// The Turbo Frame request replaces the entire section once loaded.
export default class extends Controller {
  static targets = ["btn", "spinner"]

  start() {
    if (this.hasBtnTarget)     this.btnTarget.classList.add("d-none")
    if (this.hasSpinnerTarget) this.spinnerTarget.classList.remove("d-none")
  }
}
